(function() {
  var selector = '.temu-rolling-modernized';
  var states = new WeakMap();
  var active = new Map();
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var state = active.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      updateTimer(state);
    });
  }) : null;

  function updateTimer(state) {
    if (!state.el.isConnected || !state.visible || document.hidden) {
      clearTimeout(state.timer);
      state.timer = null;
      return;
    }
    if (state.timer !== null) return;
    var delay = rand(6000, 10000);
    if (state.first) delay += rand(6000, 10000);
    state.timer = setTimeout(function() {
      state.timer = null;
      if (!state.el.isConnected || !state.visible || document.hidden) return;
      state.first = false;
      state.next();
      updateTimer(state);
    }, delay);
  }

  function connect(state) {
    if (active.has(state.el)) return;
    active.set(state.el, state);
    state.visible = !observer;
    if (observer) observer.observe(state.el);
    updateTimer(state);
  }

  function disconnect(el) {
    var state = active.get(el);
    if (!state || el.isConnected) return;
    clearTimeout(state.timer);
    state.timer = null;
    if (observer) observer.unobserve(el);
    active.delete(el);
  }

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initOne(el) {
    if (!el) return;
    if (states.has(el)) {
      connect(states.get(el));
      return;
    }
    if (el.dataset.temuInit === "1") return;
    el.dataset.temuInit = "1";

    // 20% sem bloco (natural)
    if (Math.random() < 0.20) {
      el.style.display = "none";
      return;
    }

    // Preenche textos dinâmicos
    var priceEl = el.querySelector('.price-drop-value');
    if (priceEl) {
      var cents = Math.floor(Math.random() * 2951) + 50; // 0,50..30,00
      var val = (cents / 100).toFixed(2).replace('.', ',');
      priceEl.textContent = 'R$ ' + val;
    }

    var collSpan = el.querySelector('.rank-coll');
    if (collSpan) {
      var coll = el.getAttribute('data-coll-title') || 'categoria';
      collSpan.textContent = coll;
    }

    var items = el.querySelectorAll('.temu-rolling-item-modern');
    if (!items.length) return;

    // ordem aleatória por bloco
    var order = Array.from(items).map(function(_, i) { return i; });
    for (var i = order.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = order[i];
      order[i] = order[j];
      order[j] = t;
    }

    var idx = Math.floor(Math.random() * order.length);
    function show(k) {
      for (var a = 0; a < items.length; a++) {
        items[a].classList.remove('active');
      }
      items[order[k]].classList.add('active');
    }

    show(idx);
    var state = {
      el: el,
      timer: null,
      first: true,
      visible: false,
      next: function() {
        idx = (idx + 1) % order.length;
        show(idx);
      }
    };
    states.set(el, state);
    connect(state);
  }

  function visit(root, callback) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function scan() {
    visit(document.documentElement, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('visibilitychange', function() {
    active.forEach(updateTimer);
  });

  // Examina apenas os trechos alterados e libera timers de cards removidos.
  try {
    new MutationObserver(function(records) {
      records.forEach(function(record) {
        record.removedNodes.forEach(function(node) { visit(node, disconnect); });
        record.addedNodes.forEach(function(node) { visit(node, initOne); });
      });
    })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
